import { useState } from "react";
import TopNav from "@/pages/home/components/TopNav";
import Hero from "@/pages/home/components/Hero";
import EvidenceEntries from "@/pages/home/components/EvidenceEntries";
import EvidenceFlow from "@/pages/home/components/EvidenceFlow";
import TimelineCheck from "@/pages/home/components/TimelineCheck";
import SourceNote from "@/pages/home/components/SourceNote";
import FaqSection from "@/pages/home/components/FaqSection";
import CtaSection from "@/pages/home/components/CtaSection";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  const [query, setQuery] = useState("");
  const [activeType, setActiveType] = useState("all");

  return (
    <div className="min-h-screen w-full bg-background-50 font-sans">
      <TopNav onSearch={setQuery} />

      <main>
        <Hero onSearch={setQuery} />

        <section id="archive" className="w-full border-t border-background-200 py-14 md:py-20">
          <EvidenceEntries activeType={activeType} onSelectType={setActiveType} />
          <div className="mt-10 md:mt-14">
            <EvidenceFlow
              query={query}
              onQueryChange={setQuery}
              activeType={activeType}
              onTypeChange={setActiveType}
            />
          </div>
        </section>

        <TimelineCheck />
        <SourceNote />
        <FaqSection />
        <CtaSection />
      </main>

      <SiteFooter />
    </div>
  );
}